import request from '@/services/interceptor.js'

export const get_storico_output = (filtro) => {
    return request({
        url: 'StoricoOutput',
        method: 'post',
        data: filtro,
        loadingBar: true
    })
};
